/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Add, ExpandMore, Search } from '@mui/icons-material';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Grid, Tab, Table, TableCell, TableHead, TableRow, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';

import { ButtonsDamInformation, FormDialog, ForwardedMapRender, MarkerPoint, PlanAndSections, ToolsDamInformation } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { useNavigate, useParams } from 'react-router-dom';
import { VMenu } from '../../components/shared';
import { InstrumentsServices } from '../../services/api/instruments/InstrumentosServices';
import { DamsServices, IDam, IInstrumento } from '../../services/api/dams/DamServices';
import Modelo3D from '../../components/custom/3dView/Modelo3D';
import Planta3D from '../../components/custom/3dView/Planta3D';
import { useAuthContext } from '../../context';
import { IPlants } from '../../services/api/plants/PlantsServices';
import { formatDateWhitoutHour, helpers } from '../../services/helpers/helpers';

// import { NivelAcesso, SubNivelAcesso } from '../../services/api/users/UserServices';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3, display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 'calc(100vh - 200px)' }}>
					<Typography component="div" sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export const MonitoringInstrumentation = () => {

	const url = useParams();
	const navigate = useNavigate();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const [dataInstrumentos, setDataInstrumentos] = useState<IInstrumento[]>([]);
	const [dataMap, setDataMap] = useState<IDam>();

	const [value, setValue] = React.useState(0);

	const [piezometro, setPiezometro] = useState<IInstrumento[]>([]);
	const [indicador, setIndicador] = useState<IInstrumento[]>([]);
	const [poco, setPoco] = useState<IInstrumento[]>([]);
	const [vazao, setVazao] = useState<IInstrumento[]>([]);
	const [regua, setRegua] = useState<IInstrumento[]>([]);
	const [re, setRe] = useState<IInstrumento[]>([]);
	const [base, setBase] = useState<IInstrumento[]>([]);
	const [inclinometro, setInclinometro] = useState<IInstrumento[]>([]);
	const [pluviometrico, setPluviometrico] = useState<IInstrumento[]>([]);
	const [topografico, setTopografico] = useState<IInstrumento[]>([]);

	const [center, setCenter] = useState<[number, number]>();
	const [instrumentos, setInstrumentos] = useState<IInstrumento[]>();
	const [showLabel, setShowLabel] = useState(true);
	const mapRef = useRef<HTMLDivElement>(null);
	const [isLoading, setIsLonding] = useState(true);
	const [markerPoints, setMarkerPoints] = useState<MarkerPoint[]>([]);
	const { userData } = useAuthContext();
	const [dialog, setDialog] = useState<boolean>(false);
	const [data, setData] = useState<IPlants[]>([]);

	const pagePermissionsString: string | undefined = useMemo(() => {
		return userData?.nivel_acesso?.acompanhamentos?.visualizacao;
	}, [userData]);

	const hasActionPermission = (action: 'add' | 'edit' | 'remove' | 'view'): boolean => {
		if (typeof pagePermissionsString === 'string' && pagePermissionsString !== '') {
			const actions = pagePermissionsString.split(',').map(s => s.trim());
			return actions.includes(action);
		}
		return false;
	};

	const handleDialogChange = () => {
		if (!hasActionPermission('add')) {
			console.warn('Tentativa de abrir diálogo de nova seção sem permissão de "add".');
			return;
		}
		setDialog(!dialog);
	};

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	useEffect(() => {
		fetchDataInstrumentos();
		fetchDataMap();
	}, []);

	const fetchDataInstrumentos = () => {
		if (url.dam) {
			InstrumentsServices.get(url.dam)
				.then((result) => {
					if (result instanceof Error) {
						console.log(result);
					} else {
						setDataInstrumentos(result);
						setPiezometro(result.filter(index => index.tipo_instrumento === 'piezometro'));
						setIndicador(result.filter(index => index.tipo_instrumento === 'indicador'));
						setPoco(result.filter(index => index.tipo_instrumento === 'poco'));
						setVazao(result.filter(index => index.tipo_instrumento === 'vazao'));
						setRegua(result.filter(index => index.tipo_instrumento === 'regua'));
						setRe(result.filter(index => index.tipo_instrumento === 're'));
						setBase(result.filter(index => index.tipo_instrumento === 'base'));
						setInclinometro(result.filter(index => index.tipo_instrumento === 'inclinometro'));
						setPluviometrico(result.filter(index => index.tipo_instrumento === 'pluviometro'));
						setTopografico(result.filter(index => index.tipo_instrumento === 'marco'));
					}
				});
		}
	};

	const fetchDataMap = () => {
		if (url) {
			if (url.dam) {
				DamsServices.getById(url.dam)
					.then((response) => {
						if (response instanceof Error) {
							console.log(response.message);
						} else {
							if (response.latitude && response.longitude) {
								setCenter([Number(response.latitude), Number(response.longitude)]);
								setDataMap(response);
							}
							if (response.instrumentos) {
								setInstrumentos(response.instrumentos);
							}
							setIsLonding(false);
						}
					});
			}
		}
	};

	function newInstrument() {
		if (!hasActionPermission('add')) {
			console.warn('Tentativa de adicionar novo instrumento sem permissão de "add".');
			return;
		}
		if (url.dam) {
			navigate(`/information_dam/${url.dam}/instrument/new`);
		}
	}

	function handleLabelChange(newShowLabel: boolean) {
		setShowLabel(newShowLabel);
	}

	function setMarkers(instrumentos: any[]): MarkerPoint[] {
		console.log('instrumentos');
		console.log(instrumentos);
		return instrumentos.map((instrumento, index) => {
			const uuid: string = instrumento.uuid;
			const position: [number, number] = [instrumento.latitude, instrumento.longitude];
			const title: string = instrumento.nome;
			const type: string = instrumento.tipo_instrumento;
			const ew: string = instrumento.utm_ew;
			const ns: string = instrumento.utm_ns;
			const elev: number = instrumento.elevacao ?? 'Não informado';
			const update: string = formatDateWhitoutHour(instrumento.update_date);
			const icone: string = instrumento.icone;
			const route = `instrument/${index}`;
			const showMarker = true;
			const faixa_verde: string = instrumento.limite_faixa_verde;
			const faixa_amarela: string = instrumento.limite_faixa_amarela;
			const faixa_laranja: string = instrumento.limite_faixa_laranja;
			const faixa_vermelha: string = instrumento.limite_faixa_vermelha;
			const nivel_alerta: string = instrumento.nivel_alerta;
			return { uuid, position, title, type, ew, ns, elev, route, update, showMarker, icone, faixa_verde, faixa_amarela, faixa_laranja, faixa_vermelha, nivel_alerta };
		});
	}

	useEffect(() => {
		if (instrumentos !== undefined) {
			const newMarkerPoints = setMarkers(instrumentos);
			setMarkerPoints(newMarkerPoints);
		}
	}, [instrumentos]);

	const handleShowMarkerChange = (id: string) => {
		const index = markerPoints.findIndex(marker => marker.uuid === id);
		if (index !== -1) {
			const updatedMarkerPoints = [...markerPoints];
			updatedMarkerPoints[index] = {
				...updatedMarkerPoints[index],
				showMarker: !updatedMarkerPoints[index].showMarker
			};
			setMarkerPoints(updatedMarkerPoints);
		}
	};

	const handleDisableMarkersOfType = (markerType: string, enable: boolean) => {
		const updatedMarkerPoints = markerPoints.map(marker => {
			if (marker.type === markerType) {
				return {
					...marker,
					showMarker: enable
				};
			}
			return marker;
		});
		setMarkerPoints(updatedMarkerPoints);
	};

	const InstrumentAccordion = ({ instrumento, name }: { instrumento: IInstrumento[], name: string }) => {
		return (
			<Box padding={1}>
				<Accordion square={true} sx={{ borderRadius: '30px', '&:before': { display: 'none', } }} disableGutters variant='outlined'
				>
					<AccordionSummary expandIcon={<ExpandMore />}>
						<Typography>{helpers.mapNomeInstrumento(name)}</Typography>
					</AccordionSummary>
					<AccordionDetails>
						{instrumento.map((index) => (
							<Box key={index.uuid} padding={1}>
								<Grid container alignItems='center' justifyContent='space-between' spacing={1}>
									<Grid item>
										<Typography>{index.nome}</Typography>
									</Grid>
									<Grid item>
										<Button
											startIcon={<Search />}
											onClick={() => navigate(
												`/information_dam/${url.dam}/instrument/${index.uuid}`,
												{ state: { isReadOnlyMode: !hasActionPermission('edit') } }
											)}
										>
											Detalhes
										</Button>
									</Grid>
								</Grid>
								<Divider />
							</Box>
						))}
					</AccordionDetails>
				</Accordion>
			</Box>
		);
	};

	return (
		<LayoutBase title='Monitoramento e Instrumentação'
			tollBar={
				<ToolsDamInformation
					showSearch={false}
				/>
			}
		>
			<Box width={'100%'}>
				<VMenu id={url.dam} />
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }} justifyContent={'space-around'} display={'flex'}>
					<Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile>
						<Tab label="Instrumentação" {...a11yProps(0)} />
						{hasActionPermission('view') && <Tab label="Mapa e planta" {...a11yProps(1)} />}
						{hasActionPermission('view') && <Tab label="Seções" {...a11yProps(2)} />}
						{hasActionPermission('view') && <Tab label="3D" {...a11yProps(3)} />}
					</Tabs>
				</Box>
				<CustomTabPanel value={value} index={0}>
					<Box width='100%' justifyContent='center' alignContent='center'>
						<Box width='100%'>
							<Box display={'flex'} justifyContent={'end'}>
								{hasActionPermission('add') && (
									<Button startIcon={<Add />} variant='contained' sx={{ borderRadius: '25px' }} onClick={newInstrument}>Novo Instrumento</Button>
								)}
							</Box>
							<Box width='100%' marginTop={1}>
								<>
									{piezometro.length > 0 && <InstrumentAccordion instrumento={piezometro} name="piezometro" />}
									{indicador.length > 0 && <InstrumentAccordion instrumento={indicador} name="indicador" />}
									{poco.length > 0 && <InstrumentAccordion instrumento={poco} name="poco" />}
									{vazao.length > 0 && <InstrumentAccordion instrumento={vazao} name="vazao" />}
									{regua.length > 0 && <InstrumentAccordion instrumento={regua} name="regua" />}
									{re.length > 0 && <InstrumentAccordion instrumento={re} name="re" />}
									{base.length > 0 && <InstrumentAccordion instrumento={base} name="base" />}
									{inclinometro.length > 0 && <InstrumentAccordion instrumento={inclinometro} name="inclinometro" />}
									{pluviometrico.length > 0 && <InstrumentAccordion instrumento={pluviometrico} name="pluviometro" />}
									{topografico.length > 0 && <InstrumentAccordion instrumento={topografico} name="marco" />}
								</>
							</Box>
						</Box>
					</Box>
				</CustomTabPanel>
				<CustomTabPanel value={value} index={1}>
					<Box
						display="flex"
						flexDirection={isMobile ? 'column' : 'row'}
						flexGrow={1}
						height={isMobile ? 'auto' : '100%'}
						mb={isMobile ? 2 : 0}
					>
						<Box
							width={isMobile ? '100%' : '70%'}
							height={isMobile ? '60vh' : '100%'}
							minHeight={isMobile ? '300px' : 'auto'}
							mb={isMobile ? 2 : 0}
							sx={{ flexGrow: isMobile ? 1 : 'none' }}
						>
							<ForwardedMapRender
								center={center ? center : [0, 0]}
								markerPoints={markerPoints}
								show={showLabel}
								type='a'
								ref={mapRef}
								isLocation={false}
								damName=''
							/>
						</Box>
						<Box
							display="flex"
							flexDirection="column"
							width={isMobile ? '100%' : '30%'}
							sx={{
								paddingLeft: isMobile ? 0 : 2,
								paddingTop: isMobile ? 2 : 0,
								minHeight: isMobile ? 'fit-content' : 'auto',
							}}
						>
							<ButtonsDamInformation
								showLabel={showLabel}
								handleLabelChange={handleLabelChange}
								markerPoints={markerPoints}
								handleShowMarkerChange={handleShowMarkerChange}
								handleDisableMarkersOfType={handleDisableMarkersOfType}
								uuid={url.id}
								mapRef={mapRef}
							/>
						</Box>
					</Box>
					{/* <Box>
						{hasActionPermission('add') && (
							<>
								<Divider />
								<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: 1 }}>
									<Box>
										<Typography variant='h6'>Adicionar Nova Seção</Typography>
										<Typography variant='body1'>Será exibida na aba de seção</Typography>
									</Box>
									<Button
										variant='contained'
										sx={{ borderRadius: '25px', paddingY: 1 }}
										startIcon={<Add />}
										onClick={handleDialogChange}
									>
										Nova Seção
									</Button>
								</Box>
							</>
						)}
					</Box> */}
				</CustomTabPanel>
				<CustomTabPanel value={value} index={2}>
					<PlanAndSections
						// markerPoints={markerPoints}
						// handleShowMarkerChange={handleShowMarkerChange}
						// handleDisableMarkersOfType={handleDisableMarkersOfType}
						// handleLabelChange={handleLabelChange}
						// showLabel={showLabel}
						uuid={url.dam ?? ''}
					// mapRef={mapRef}
					// pagePermissions={pagePermissionsString}
					/>
				</CustomTabPanel>
				<CustomTabPanel value={value} index={3}>
					<Planta3D />
				</CustomTabPanel>
			</Box>
			<FormDialog dialog={dialog} handleDialogChange={handleDialogChange} value={data} />
		</LayoutBase>
	);
};